'use client'

import classNames from 'classnames'
import React, { useState } from 'react'

import Modal from '~/components/center-modal'

import RichText from '../rich-text/rich-text'
import HeaderSvg from './header-svg'

const Popup: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true)

  const modalTitle = 'NOTICE'
  const modalText = `
  <p>BRAZA UK LTD hereby emphasizes to all its clients, potential clients, and the general public that WE DO NOT PROVIDE LOANS, FINANCING, or INVESTMENT SERVICES SUCH AS STOCKS OR FIXED INCOME.</p>
 
  <p>Furthermore, BRAZA DOES NOT IMPOSE UPFRONT FEES for credit assessments, operational viability fees, or any form of commissions.</p>
  
  <p>If you have received any communication or proposals from an individual whose contact details you have not been able to verify as those of a legitimate BRAZA representative, PLEASE reach out to us via email at compliance@braza.uk. The authenticity of individuals claiming to represent BRAZA can be verified through the email info@braza.uk.</p>
  
  <p>AVOID MAKING ANY MONEY TRANSFERS without first confirming that you are in direct contact with authorized BRAZA representatives.</p>
  
  <p>This communication aims to SAFEGUARD clients, potential clients, and the public from fraudulent activities or communications that could lead to financial harm.</p>
  `

  return (
    <Modal isActive={isOpen} onClose={() => setIsOpen(false)}>
      <div className="pt-20 pb-10 px-8 flex justify-center">
        <div className="w-full max-w-[27.5rem] flex flex-col gap-6 lg:gap-4">
          <HeaderSvg></HeaderSvg>
          <h2 className="text-5xl">{modalTitle}</h2>
          <RichText
            className="prose-p:text-xs !gap-3 text-justify"
            html={modalText}
          />
        </div>
      </div>
    </Modal>
  )
}

export default Popup
